module.exports = __webpack_public_path__ + "static/media/DetalleCurso3.ec001950.svg";